var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 8L8.41421 7.41421C7.15428 6.15428 8.04662 4 9.82843 4H26.1716C27.9534 4 28.8457 6.15428 27.5858 7.41421L27 8M15.4142 19.4142C15.7893 19.7893 16 20.298 16 20.8284V30C16 31.1046 15.1046 32 14 32H8C6.89543 32 6 32.8954 6 34C6 35.1046 6.89543 36 8 36H28C29.1046 36 30 35.1046 30 34C30 32.8954 29.1046 32 28 32H22C20.8954 32 20 31.1046 20 30V20.8284C20 20.298 20.2107 19.7893 20.5858 19.4142L35.4142 4.58578C35.7893 4.21071 36 3.70201 36 3.17157V2C36 0.895431 35.1046 0 34 0H2C0.895431 0 0 0.895431 0 2V3.17157C0 3.70201 0.210714 4.21071 0.585786 4.58579L15.4142 19.4142Z",
    fill: "#FDCA1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.ae8d1567a5840408de1bba55161700a2.svg";
export { ForwardRef as ReactComponent };